import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './ProgrammableLogicController.frontend.types'

@Injectable({ providedIn: 'root' })
export class ProgrammableLogicController_ds_connector_mappings_getService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: {  }): Promise<{ list?: { footprint_zone?: string, connector_zone?: string, connector_id?: string, connector_name?: string, warehouse_name?: string, warehouse_id?: number }[], reasons?: string[] }> 
  {
    let $url = `${environment.backendUrl}api/ProgrammableLogicController/functions/ds_connector_mappings_get`;
    
    const $options = {
    }
    
    const $body = null;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

